/**
 * API-Konfiguration
 * Zentrale Stelle für alle API-bezogenen Konfigurationen
 */

// Basis-URL für alle API-Anfragen
export const API_BASE_URL = process.env.VUE_APP_API_URL || 'http://localhost:8000';

// API-Pfade, die innerhalb der Anwendung verwendet werden
export const API_PATHS = {
  // Auth
  LOGIN: '/api/login',
  LOGOUT: '/api/logout',
  REGISTER: '/api/register',
  USER: '/api/user',
  CSRF_TOKEN: '/sanctum/csrf-cookie',
  IMPERSONATION_DATA: '/api/auth/impersonation-data',
  STOP_IMPERSONATING: '/api/stop-impersonating',
  
  // Companies
  COMPANIES: '/api/companies',
  COMPANY: '/api/company',
  COMPANY_CURRENT: '/api/company/current',
  COMPANY_SETTINGS: '/api/company/settings',
  COMPANY_DASHBOARD: '/api/company/dashboard',
  
  // Admin
  ADMIN_COMPANIES: '/api/admin/companies',
  ADMIN_DASHBOARD: '/api/admin/dashboard',
  ADMIN_ANALYTICS: '/api/admin/analytics',
  ADMIN_ANALYTICS_MONTHLY: '/api/admin/analytics/monthly-stats',
  ADMIN_IMPERSONATE_COMPANY: (companyId) => `/api/admin/impersonate/company/${companyId}`,
  
  // Tests und Fragen
  TESTS: '/api/tests',
  TEST_CREATE: '/api/tests',
  TEST_UPDATE: (id) => `/api/tests/${id}`,
  TEST_DELETE: (id) => `/api/tests/${id}`,
  TEST_QUESTIONS: (testId) => `/api/tests/${testId}/questions`,
  QUESTION_CREATE: (testId) => `/api/tests/${testId}/questions`,
  QUESTION_UPDATE: (testId, questionId) => `/api/tests/${testId}/questions/${questionId}`,
  QUESTION_DELETE: (questionId) => `/api/questions/${questionId}`,
  QUESTIONS_REORDER: (testId) => `/api/tests/${testId}/questions/reorder`,
  TESTS_QUESTION_COUNT: '/api/tests/question-counts',
  TESTS_REORDER: '/api/tests/reorder',
  
  // Other resources
  USERS: '/api/users',
  PROFILE: '/api/profile',
  APPLICANTS: '/api/applicants',
  ENTRIES: '/api/entries',
  DASHBOARD_STATS: '/api/dashboard/stats',
  DASHBOARD_RECENT_TESTS: '/api/dashboard/recent-tests',
  DASHBOARD_RECENT_ACTIVITIES: '/api/dashboard/recent-activities',
};

export default {
  API_BASE_URL,
  API_PATHS
}; 